var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-logged-notification"},[_c('span',{staticClass:"icon-info"}),(_vm.isFreeOrPromotional)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('CourseOverview.notes_non_logged_in_free'))}}):_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('CourseOverview.notes_non_logged_in'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }